export default "<p>general-terms-of-sale works!</p>\n"